module.exports = __webpack_public_path__ + "./kit/docs/img/icon-setter.d13c3525e6365353b7ff7eda5da67fb7.svg";